import styled from '@emotion/styled';
import { colors } from '@modernanimal/common';

import PrimaryButton from '../components/PrimaryButton';
import Fonts from '../fonts';
import { DOWNLOAD_APP_LINK, HREF_TARGET } from '../helpers';
import images from '../images';

const CONTACT_PHONE_NUMBER = '(855) 228-7066';

const ExistingAccount = () => (
    <ExistingAccountContainer>
        <Body>
            <Instructions>
                <Fonts.Heading04>
                    {'You already have a Modern Animal account.'}
                </Fonts.Heading04>
                <DownloadButton>
                    <PrimaryButton color="periwinkle" onClick={() => window.open(DOWNLOAD_APP_LINK, HREF_TARGET)}>
                        Download the app to book
                    </PrimaryButton>
                </DownloadButton>
                <Fonts.Body style={{ color: colors.GREY_2 }}>
                    {'It looks like you tried to book an appointment using an existing email or phone number. Please download the app and log in using your phone number to continue.'}
                    <br />
                    <br />
                    {'The app is the best place to book and manage appointments, access your pet\'s health records, and access free 24/7 virtual care. '}
                    {'If you prefer, you can reach out to '}
                    <Link
                        href={`tel:${CONTACT_PHONE_NUMBER}`}
                        style={{ textDecoration: 'none' }}
                    >
                        {CONTACT_PHONE_NUMBER}
                    </Link>
                    {' for help booking this appointment.'}
                </Fonts.Body>
            </Instructions>
            <PreviewImage src={images.DownloadApp} />
        </Body>
    </ExistingAccountContainer>
);

export default ExistingAccount;

const ExistingAccountContainer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 32px 24px;
    justify-content: space-between;
    gap: 24px;
`;

const Body = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: center;
`;

const Instructions = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const Link = styled.a`
    color: ${colors.PRIMARY_PERIWINKLE};
`;

const PreviewImage = styled.img`
    width: 100%;
`;

const DownloadButton = styled.div`
    padding: 12px 0;
`;
